import React from 'react'

interface FieldErrorProps {
    error?: string
}

export const FieldError = ({ error }: FieldErrorProps) => {
    if (!error) return null
    return (
        <label className="form-label">
            <div
                className="label--text"
                style={{ color: 'var(--danger)' }}
            >
                <span>{error}</span>
            </div>
        </label>
    )
}
